<template>
  <div>
    <a
      class="
        font-AvenirBlackFont
        mt-auto
        ml-auto
        hover:underline
        cursor-pointer
        text-gray-600 text-sm
      "
      @click="downloadAll"
      >Download all
    </a>
  </div>
</template>

<script>
import JSZip from "jszip";
import JSZipUtils from "jszip-utils";
import { saveAs } from "file-saver";
import getAllURLs from "../api/getAllURLs";

export default {
  name: "DownloadAll",

  props: {
    data: Array,
  },

  methods: {
    getPressReleaseName(data) {
      return data.split("/").pop().split("?").shift();
    },

    async zipData() {
      const URLs = await getAllURLs(this.data);
      const zipName = "docs";
      const zip = new JSZip();
      let count = 0;

      URLs.forEach((data, _, array) => {
        const name = this.getPressReleaseName(data);

        JSZipUtils.getBinaryContent(data, function (err, res) {
          if (err) {
            throw err;
          }

          zip.file(name, res, { binary: true });
          count++;

          if (count === array.length) {
            zip.generateAsync({ type: "blob" }).then(function (content) {
              saveAs(content, zipName);
            });
          }
        });
      });
    },

    async downloadAll() {
      this.$emit("downloadAll", this.zipData);
    },
  },
};
</script>
